module.exports = __webpack_public_path__ + "static/media/analyse_cv_i.e24aaf68.jpg";